import { render, staticRenderFns } from "./AdditionalList.vue?vue&type=template&id=b1592d7c&"
import script from "./AdditionalList.vue?vue&type=script&lang=js&"
export * from "./AdditionalList.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports